module.exports = __webpack_public_path__ + "static/img/无订单.b72b5a63.png";